import { Box, Typography } from "@mui/material";
import { Icon } from "components/icon";
import { IconName } from "types/Common";

type AdditionalInfoProps = {
  title: string;
  description: string;
  icon: IconName;
};
export const AdditionalInfo = ({ icon, title, description }: AdditionalInfoProps) => {
  return (
    <Box display="flex" gap={5}>
      <Icon name={icon} size={40} />
      <Box maxWidth={470}>
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="body1" lineHeight={2.5}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
};
